import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const IconCalendarEnd = props => (
  <SvgIcon {...props} viewBox="0 0 14 16">
    <path d="m10.5 8.8887h-3.5v3.5555h3.5v-3.5555zm-0.389-8.8887v1.6h-6.2222v-1.6h-1.5556v1.6h-0.77777c-0.86318 0-1.5476 0.72-1.5476 1.6l-0.0078 11.2c0 0.88 0.69222 1.6 1.5556 1.6h10.888c0.856 0 1.556-0.72 1.556-1.6v-11.2c0-0.88-0.7-1.6-1.556-1.6h-0.7777v-1.6h-1.5556zm2.1389 14.222h-10.5v-8.8889h10.5v8.8889z" />
  </SvgIcon>
);

export default IconCalendarEnd;



// WEBPACK FOOTER //
// ./src/components/icons/IconCalendarEnd.js